<template>
  <div id="userLeft">
    <div class="userInfo">
      <img
        v-if="userInfo.headPhoto"
        v-lazy="
          userInfo.headPhoto
            ? $global.imgUrl + userInfo.headPhoto
            : '@/assets/img/login/4.png'
        "
        alt=""
      />
      <img v-else src="@/assets/img/login/4.png" alt="" />
      <span class="name">{{
        isSonUser === "true"
          ? userInfo.account.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2")
          : userInfo.user.customerType === 1
          ? userInfo.account.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2")
          : userInfo.user.customerType === 2
          ? userInfo.name
          : userInfo.companyName
      }}</span>
      <div class="fb" @click="handleClick">发布</div>
      <ul class="navList" v-if="flag">
        <li v-for="(item, i) in navLists" :key="i">
          <router-link :to="{ path: item.path, query: { title: item.name } }"
            >{{ item.name }}
          </router-link>
        </li>
      </ul>
    </div>
    <div class="tree">
      <myTree></myTree>
    </div>
    <AuthenticationModel
      v-if="isFlag"
      @handleClose="isFlag = false"
    ></AuthenticationModel>
  </div>
</template>

<script>
import myTree from "./myTree";
import { mapState } from "vuex";
import AuthenticationModel from "./AuthenticationModel.vue";

export default {
  components: {
    myTree,
    AuthenticationModel,
  },
  // filters: {
  //   reg(val) {
  //     return val;
  //   }
  // },
  name: "left",
  computed: {
    isSonUser() {
      return sessionStorage.getItem("isSon");
    },
    ...mapState(["userInfo"]),
    navLists() {
      let nav = [];
      if (this.navList) {
        for (let i = 0; i < this.navList.length; i++) {
          const item = this.navList[i];
          if (item.name === "资讯") {
            nav.push({
              ...item,
              path: "/informationForm",
            });
          } else if (item.name === "论文") {
            nav.push({
              ...item,
              path: "/paperForm",
            });
          } else if (item.name === "报告") {
            nav.push({
              ...item,
              path: "/reportform",
            });
          } else if (item.name === "专著") {
            nav.push({
              ...item,
              path: "/monographForm",
            });
          } else if (item.name === "征稿函") {
            nav.push({
              ...item,
              path: "/zghForm",
            });
          } else if (item.name === "会议") {
            nav.push({
              ...item,
              path: "/conferenceForm",
            });
          } 
          // else if (item.name === "课程") {
          //   nav.push({
          //     ...item,
          //     path: "/courseForm",
          //   });
          // }
        }
      }
      return nav;
    },
  },
  mounted() {
    if (JSON.parse(sessionStorage.getItem("userInfo")).permissionUrls[9]) {
      this.navList = JSON.parse(
        sessionStorage.getItem("userInfo")
      ).permissionUrls[9];
    }
    this.$bus.$on("mainDocument", this.handleDocument);
  },
  beforeDestroy() {
    this.$bus.$off("mainDocument", this.handleDocument);
  },
  data() {
    return {
      navList: [],
      flag: false,
      isFlag: false,
    };
  },
  methods: {
    handleDocument(e) {
      if (e.target.className !== "fb") {
        this.flag = false;
      }
    },
    handleClick() {
      if (
        sessionStorage.getItem("isSon") == "true" &&
        !JSON.parse(sessionStorage.getItem("userInfo")).permissionUrls[9]
      ) {
        this.$Message.error("该账号暂未分配发布权限，请联系主账号进行权限分配");
      } else {
        if (!JSON.parse(sessionStorage.getItem("userInfo")).permissionUrls[9]) {
          this.isFlag = true;
          this.flag = false;
        } else {
          this.flag = !this.flag;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#userLeft {
  width: 200px;
  display: flex;
  flex-wrap: wrap;

  .tree {
    width: 200px;
    margin-left: 0px;
    margin-top: 30px;
  }

  .userInfo {
    margin-bottom: 54px;
    margin-top: 13px;
    width: 120px;
    margin-left: 30px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    position: relative;
    .fb {
      cursor: pointer;
    }
    // .fb:hover {
    //   & + .navList {
    //     display: block;
    //   }
    // }

    .navList {
      width: 120px;
      text-align: center;
      position: absolute;
      left: 0;
      top: 156px;
      overflow: auto;
      margin: 5px 0;
      padding: 5px 0;
      background-color: #fff;
      box-sizing: border-box;
      border-radius: 4px;
      box-shadow: 0 1px 6px rgb(0 0 0 / 20%);

      &:hover {
        display: block;
      }

      li {
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        text-align: center;
        height: 40px;
        line-height: 40px;
        margin: 0;
        clear: both;
        color: #515a6e;
        cursor: pointer;
        transition: background 0.2s ease-in-out;

        &:hover {
          background: #f3f3f3;
          display: block;
        }

        a {
          display: block;
          width: 100%;
          height: 100%;
          color: #333;
        }
      }
    }

    span {
      width: 113px;
      margin-top: 8px;
      margin-bottom: 10px;
      //height: 19px;
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #263d78;
      text-align: center;

      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      line-height: 24px;
    }

    img {
      width: 84px;
      height: 84px;
      border-radius: 50%;
    }

    div {
      width: 120px;
      height: 40px;
      margin: 0 auto;
      background: #02157e;
      border-radius: 20px;
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;
      text-align: center;
      line-height: 40px;
    }
  }
}
</style>
